import React, { useCallback, useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import BackButton from 'components/BackButton';
import InvoiceFilterBar, {
  InvoiceFilterKey,
  InvoiceReportTotal,
} from 'components/invoices/InvoiceFilterBar';
import InvoicesTable, { InvoicesTableSearchFilters } from 'components/invoices/InvoicesTable';
import usePastDuePayments from 'hooks/reports/payments/usePastDuePayments';
import { useNavigate } from 'react-router-dom';
import { Invoice } from 'types';

// Status is hidden: the report hard-filters PAST DUE and FAILED PAST DUE, so a
// user-facing status control would only let you contradict the report.
const FILTERS: InvoiceFilterKey[] = ['productType', 'billingSources', 'paymentMethods'];

const PastDuePayments = (): JSX.Element => {
  const navigate = useNavigate();

  const initialSearchFiltersValue: InvoicesTableSearchFilters = {
    productType: '',
    billingSources: [],
    status: ['PAST DUE', 'FAILED PAST DUE'] as Array<Invoice['status']>,
    paymentMethods: [],
  };

  const [searchFilters, setSearchFilters] = useState<InvoicesTableSearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<InvoicesTableSearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState('dueDate');

  const total = usePastDuePayments({ ...searchFilters });

  const handleBackClick = useCallback((): void => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      <InvoiceFilterBar
        source='past-due-payments'
        title='Past Due'
        filters={FILTERS}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
        csvReportType='past-due-payments'
        leftSection={<BackButton handleOnClick={handleBackClick} />}
        titleDataCy='totalPastDueAmountHeader'
        titleSuffix={<InvoiceReportTotal query={total} color='red' />}
      />

      <InvoicesTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default PastDuePayments;
